// extracted by mini-css-extract-plugin
export default {"root":"root--e94cefd","editSection":"editSection--43135f2","number":"number--2c93246","error":"error--02363e5"};